import React, { useEffect } from 'react';

import { connect } from 'react-redux';

import {
  Loading,
  PageHeader,
  DashboardInfoCard,
  DashboardInfoCardList,
} from '../../components';

import useComponentState from '../../utils/useComponentState';
import { getCustomersSummary } from '../../api/DashboardAnalytics';
import { formatNumber } from './DashboardAnalyticsConstants';

import styles from './DashboardAnalytics.module.scss';

const DashboardAnalytics = (props) => {
  const [state, setState] = useComponentState({
    summary: null,
    loading: true,
    error: null,
  });

  const {
    auth: { token },
  } = props;
  const { summary, loading, error } = state;

  const handleGetCustomersSummary = async () => {
    try {
      setState({ loading: true, error: null });
      const response = await getCustomersSummary(token);
      setState({ loading: false, summary: response });
    } catch (err) {
      setState({
        loading: false,
        error: err.message || 'Oops, something went wrong. Please try again',
      });
    }
  };

  const renderInactiveByDpd = () => {
    const inactiveByDpdStatus = summary?.inactiveByDpdStatus || {};
    const entries = Object.entries(inactiveByDpdStatus).filter(
      ([dpd]) => dpd !== 'UNKNOWN'
    );

    if (entries.length === 0) return null;

    return (
      <div className={styles.section}>
        <PageHeader text='Inactive by DPD Status' />
        <DashboardInfoCardList>
          {entries.map(([dpd, count]) => (
            <DashboardInfoCard
              key={dpd}
              label={`${dpd} DPD`}
              value={formatNumber(count)}
            />
          ))}
        </DashboardInfoCardList>
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className={styles.content}>
        <div className={styles.section}>
          <PageHeader text='Customers Enrolled in Rewards' />
          <DashboardInfoCardList>
            <DashboardInfoCard
              label='Total Enrolled'
              value={formatNumber(summary.totalEnrolled)}
            />
            <DashboardInfoCard
              label='Active'
              value={formatNumber(summary.active)}
            />
            <DashboardInfoCard
              label='Inactive'
              value={formatNumber(summary.inactive)}
            />
          </DashboardInfoCardList>
        </div>
        {renderInactiveByDpd()}
      </div>
    );
  };

 useEffect(() => {
    handleGetCustomersSummary();
  }, []);

  return (
    <div className={styles.root_div}>
      {loading ? (
        <Loading text='Loading Dashboard Analytics' />
      ) : error ? (
        <div className={styles.error}>{error}</div>
      ) : (
        renderContent()
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth.auth,
  };
};

export default connect(mapStateToProps)(DashboardAnalytics);
